  <div *ngIf="isSkpModalShown"
    [config]="{show: true,backdrop: masterService.modals_backdrop.confirm_modal}"
    (onHidden)="onHidden()"
    bsModal
    #autoShownModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true">  
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="px-4 pt-3 ">
          <div class="row">
            <div class="col-6">
              <h6 class="heading-4">
                Certificate<span *ngIf="mls?.is_lskey_display == 1">
                (view_skp_points.key9)</span>
              </h6>
            </div>
            <div class="col-6">
              <span class="cursor-pointer float-right" (click)="hideModal()">
               <img src="assets/themes/icons/cancel.svg" alt="cancel" (click)="hideModal()" />
              </span>
            </div>
          </div>
        </div>
        <div class="modal-body pt-2 pb-2">
          <div class="form-input">
            <label class="secondary-paragraph">
              <span class="color-grey-500">{{ vaultObj?.header_text}}
              </span><span *ngIf="mls?.is_lskey_display == 1">
                (view_skp_points.key10)</span>
            </label>
            <p class="mb-3 clearfix">
              <span class="mr-2 chip small outline info icon-position-left">
                <img src="assets/themes/icons/cme-points.svg"  width="15px" alt="cme" />
                {{ vaultObj?.score }} {{ vaultObj?.point_name }}</span> 
            </p>
          </div>

          <div class="form-input">
            <label class="secondary-paragraph">
              <span class="color-grey-500">Course Title</span><span *ngIf="mls?.is_lskey_display == 1">
                (view_skp_points.key1)</span>
            </label>
            <p class="heading-4">
              {{ vaultObj?.event_name }}
            </p>
          </div>

          <div class="mb-3" *ngIf="vaultObj?.certificate != 0">
            <label
              *ngIf=" vaultObj?.certificate_url != '' && vaultObj?.certificate_url != undefined "
              class="secondary-paragraph">
              <span class="color-grey-500">{{ mls.languageText.view_skp_points.key2}}</span>
              <span *ngIf="mls?.is_lskey_display == 1">(view_skp_points.key2)</span> 
            </label>
          </div>
          <div class="row mb-3">
            <div class="mb-2 col-6 " *ngIf="vaultObj?.date_of_submission != ''" >
              <label class="secondary-paragraph">
                <span class="color-grey-500">{{ mls.languageText.view_skp_points.key6}}
                </span><span *ngIf="mls?.is_lskey_display == 1">
                 (view_skp_points.key6)</span>
              </label>
              <p class="heading-4">
                {{ vaultObj?.date_of_submission | date }} 
              </p>
            </div>
            <div *ngIf="vaultObj?.end_date != ''" class="mb-2 col-6">
              <label class="secondary-paragraph">
                <span class="color-grey-500">{{ mls.languageText.view_skp_points.key7}}</span>
                <span *ngIf="mls?.is_lskey_display == 1">(view_skp_points.key7)</span>
              </label>
              <p class="heading-4">
                {{ vaultObj?.end_date | date }}
              </p>
            </div>
          </div>
          <div *ngIf="vaultObj?.tag_name != undefined && vaultObj?.tag_name != ''" class="mb-3">
            <label class="secondary-paragraph">
              <span class="color-grey-500">{{ mls.languageText.view_skp_points.key8}}</span>
              <span *ngIf="mls?.is_lskey_display == 1">(view_skp_points.key8)</span>
            </label>
            <p class="heading-4">
              {{ vaultObj?.tag_name }}
            </p>
          </div>
          <div class="row mb-3 border-line">
            <div class="col-6">
              <div *ngIf="vaultObj.certificate_url != ''" class="float-left mr-2">
                <img
                  *ngIf="certificateType != 'pdf'"
                  src="{{ vaultObj?.certificate_url }}"
                  onerror="this.src='assets/images/grandround/image_placeholder.svg'"
                  class="rounded border skp-certificate"/>
                
                <div class="rounded border skp-certificate overflow-hidden" *ngIf="certificateType == 'pdf'">
                  <app-pdf-view  
                    [pdfscr]="vaultObj?.certificate_url"
                    [idx]="0"
                    [useractivity]="0">
                  </app-pdf-view>
                </div>
              </div>
            </div>
            <div class="col-6"></div>
          </div>
          <div class="row clearfix mb-3">
            <div class="col-12">
              <button
              (click)="viewCertificate()"
              class="btn-design w-100 medium filled cursor-pointer">
              {{ mls.languageText.view_skp_points.key3}}
              <span *ngIf="mls?.is_lskey_display == 1">
                (view_skp_points.key3)</span>
             </button>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-6">
              <a
              download="certificate"
              href="{{ vaultObj?.certificate_url }}"
              target="_blank"
              *ngIf="( vaultObj?.certificate_url != '' && vaultObj?.certificate_url != undefined)"
              class="btn-design outline w-100 d-block cursor-pointer medium ">
              {{ mls.languageText.view_skp_points.key4}}
               <span *ngIf="mls?.is_lskey_display == 1">
                (view_skp_points.key4)</span>
               <img class="pl-2" src="assets/themes/icons/download.svg" alt="download" />
               </a>
            </div>
            <div class="col-6">
              <button
              (click)="productShare()"
              class="btn-design medium outline w-100">
              <img class="mr-1" width="16px" src="assets/themes/icons/share.svg" alt="share" />
            {{ mls.languageText.view_skp_points.key5}}
            <span *ngIf="mls?.is_lskey_display == 1">
              (view_skp_points.key5)</span>
          </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-media-modal  
    [callingfrom]="'cme view skp points'"
    *ngIf="mediaModal == true && openMediaIndex != undefined"
    (resetMediaModal)="setResetMediaModal($event)"
    [isMediaModalShown]="mediaModal"
    [mediaObj]="mediaObj"
    [openMediaIndex]="openMediaIndex">
  </app-media-modal>